import stageShape, { stageContentFor } from "../model/stage";
import CompleteStage from "./CompleteStage";
import InProgressStage from "./InProgressStage";

import { formatStageDate } from "./helpers";

const BlueprintStage = ({ stage = null }) => {
  if (stage?.errorTitle) {
    return (
      <div className="tw-flex tw-flex-col tw-gap-[12px]">
        <div className="tw-flex tw-flex-col tw-gap-[2px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-neutral-gray-10 tw-p-[8px]">
          <span className="tw-text-14 tw-font-semibold tw-leading-20px tw-text-gray-75">
            {stage.errorTitle}
          </span>
          <span className="tw-text-12px tw-font-normal tw-leading-[16px] tw-text-gray-75">
            {stage.errorMessage}
          </span>
        </div>
      </div>
    );
  }

  const status = stage?.crmTransactionStatus;
  if (status === "complete") {
    return <CompleteStage />;
  }

  if (status === "in_progress" || status === "ready_to_close" || status === "post_closing") {
    return <InProgressStage stage={stage} />;
  }

  const content = stageContentFor(stage);

  if (!content) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[12px]">
      <div className="tw-flex tw-flex-col tw-gap-[2px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-neutral-gray-10 tw-p-[8px]">
        <span className="tw-text-14 tw-font-semibold tw-leading-20px tw-text-gray-75">
          {content.subtitle}
        </span>
        <span className="tw-text-12px tw-font-normal tw-leading-[16px] tw-text-gray-75">
          {content.description}
        </span>
      </div>
      <div className="tw-flex tw-justify-between tw-text-12px tw-font-normal tw-italic tw-leading-[16px] tw-text-gray-50">
        <span>{content.metadataLabel}</span>
        <span>{formatStageDate(stage.lastUpdated)}</span>
      </div>
    </div>
  );
};

BlueprintStage.propTypes = {
  stage: stageShape,
};

export default BlueprintStage;
